import React from "react";

const dots = (x0, y0, w, h, r, n, fill, seed = 1) => {
  let s = seed;
  const rnd = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
  return Array.from({ length: n }, (_, i) => (
    <circle key={i} cx={x0 + rnd() * w} cy={y0 + rnd() * h} r={r * (0.6 + rnd() * 0.6)} fill={fill} />
  ));
};

const Label = ({ y, n, title, sub }) => (
  <g>
    <line x1="182" y1={y} x2="214" y2={y} stroke="#8a9195" strokeDasharray="3 3" />
    <circle cx="226" cy={y} r="11" fill="#172B38" />
    <text x="226" y={y + 4} textAnchor="middle" fontSize="11" fontWeight="600" fill="#fff">{n}</text>
    <text x="244" y={y - 2} fontSize="13" fontWeight="600" fill="#172B38">{title}</text>
    <text x="244" y={y + 14} fontSize="11" fill="#5F676B">{sub}</text>
  </g>
);

export default function TankDiagram() {
  return (
    <svg data-testid="tank-diagram" viewBox="0 0 430 420" className="w-full max-w-[430px] mx-auto" role="img"
      aria-label="Diagram of the tank layers: carbon on top, softening resin in the middle, gravel at the bottom">
      <defs>
        <clipPath id="tankClip"><rect x="60" y="70" width="120" height="320" rx="56" /></clipPath>
      </defs>
      <rect x="98" y="30" width="44" height="40" rx="10" fill="#3E474B" />
      <rect x="108" y="38" width="24" height="12" rx="3" fill="#7dd3fc" />
      <path d="M30 50 H98" stroke="#344C59" strokeWidth="5" strokeLinecap="round" />
      <path d="M30 42 L38 50 L30 58" fill="none" stroke="#344C59" strokeWidth="3" strokeLinecap="round" transform="translate(60 0)" />
      <text x="22" y="34" fontSize="10" fill="#5F676B">Water in</text>
      <g clipPath="url(#tankClip)">
        <rect x="60" y="70" width="120" height="320" fill="#1e293b" />
        <rect x="60" y="100" width="120" height="120" fill="#27272a" />
        {dots(62, 102, 116, 116, 2.4, 140, "#52525b", 3)}
        <rect x="60" y="220" width="120" height="110" fill="#d97706" />
        {dots(62, 222, 116, 106, 2.2, 160, "#fbbf24", 7)}
        <rect x="60" y="330" width="120" height="60" fill="#8a9195" />
        {dots(62, 332, 116, 56, 5, 40, "#cbd5e1", 11)}
        <rect x="117" y="80" width="6" height="300" fill="#e2e8f0" opacity="0.5" />
      </g>
      <rect x="60" y="70" width="120" height="320" rx="56" fill="none" stroke="#172B38" strokeWidth="3" />
      <Label y={160} n="1" title="Jacobi carbon" sub="Filters chlorine & contaminants" />
      <Label y={275} n="2" title="Softening resin" sub="Removes hardness minerals" />
      <Label y={360} n="3" title="Polishing gravel" sub="Even flow + final filtration" />
      <text x="120" y="412" textAnchor="middle" fontSize="11" fill="#5F676B">Clean, soft water out to your home</text>
    </svg>
  );
}
